/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mesafeli_S5_Li3_BodyInputs */

const tr_mesafeli_s5_li3_body = /** @type {(inputs: Mesafeli_S5_Li3_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kart ile yapılan tüm tahsilatlar BDDK düzenlemeleri ve Sipay Sanal POS gereklilikleri uyarınca 3D Secure (3DS) kimlik doğrulama protokolüyle gerçekleştirilir. Müşteri, kart hamili sıfatıyla bankası tarafından gönderilen tek kullanımlık şifre (OTP) veya biyometrik doğrulama ile işlemi onaylar. 3DS doğrulaması tamamlanmadan tahsilat yapılamaz.`)
};

const en_mesafeli_s5_li3_body = /** @type {(inputs: Mesafeli_S5_Li3_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All card collections are carried out with the 3D Secure (3DS) authentication protocol in accordance with BDDK regulations and Sipay Sanal POS requirements. As cardholder, the Customer approves the transaction with the one-time password (OTP) sent by his bank or by biometric verification. No collection can be made before the 3DS verification is completed.`)
};

const de_mesafeli_s5_li3_body = /** @type {(inputs: Mesafeli_S5_Li3_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle Karteneinzüge werden gemäß den BDDK-Regelungen und den Anforderungen des Sipay Sanal POS mit dem Authentifizierungsprotokoll 3D Secure (3DS) durchgeführt. Der Kunde bestätigt den Vorgang als Karteninhaber mit dem von seiner Bank gesendeten Einmalkennwort (OTP) oder per biometrischer Bestätigung. Ohne abgeschlossene 3DS-Prüfung kann kein Einzug erfolgen.`)
};

const ru_mesafeli_s5_li3_body = /** @type {(inputs: Mesafeli_S5_Li3_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Все списания по карте выполняются с использованием протокола аутентификации 3D Secure (3DS) в соответствии с правилами BDDK и требованиями Sipay Sanal POS. Клиент как держатель карты подтверждает операцию одноразовым паролем (OTP), присланным его банком, либо биометрической проверкой. Без завершения проверки 3DS списание невозможно.`)
};

/**
* | output |
* | --- |
* | "All card collections are carried out with the 3D Secure (3DS) authentication protocol in accordance with BDDK regulations and Sipay Sanal POS requirements. A..." |
*
* @param {Mesafeli_S5_Li3_BodyInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const mesafeli_s5_li3_body = /** @type {((inputs?: Mesafeli_S5_Li3_BodyInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mesafeli_S5_Li3_BodyInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mesafeli_s5_li3_body(inputs)
	if (locale === "de") return de_mesafeli_s5_li3_body(inputs)
	if (locale === "ru") return ru_mesafeli_s5_li3_body(inputs)
	return tr_mesafeli_s5_li3_body(inputs)
});